module.exports = __webpack_public_path__ + "img/x14.fd11ce2a.jpg";